import type { ThemeToken } from "./theme.type";

import { theme } from "antd";
import { useMemo } from "react";

import { getAppThemeFromToken } from "./theme.helper";

export const useTheme = () => {
  const { token, hashId, cssVar } = theme.useToken();

  const appTheme = useMemo(
    () => getAppThemeFromToken(token as ThemeToken),
    [token]
  );

  return {
    ...appTheme,
    hashId,
    cssVar,
  };
};
